import React, { type FC } from 'react'

import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  Button,
  Flex,
  SidePanelSeparator,
} from 'mailup-web-components'

import { panelEditContactsSaveCallback } from 'Pages/RecipientsList/recoil/callbacks/editContacts'
import { panelEditContactsCanSaveState } from 'Pages/RecipientsList/recoil/state/editContacts'

const StyledFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: #fff;
`

const PanelEditContactsFooter: FC = () => {
  const intl = useIntl()

  const canSave = useRecoilValue(panelEditContactsCanSaveState)

  const handleSave = useRecoilCallback(panelEditContactsSaveCallback, [])

  return (
    <StyledFooter>
      <SidePanelSeparator />
      <Flex justifyContent="end" padding="16px 32px">
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="edit-contacts__save"
          disabled={!canSave}
          onClick={handleSave}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </Flex>
    </StyledFooter>
  )
}

export default PanelEditContactsFooter
